import { Skeleton } from 'antd';
import React, { useEffect, useState } from 'react';
import { IoInformationCircle } from 'react-icons/io5';
import { useGetCurrentUserQuery } from '../../api';

import CButton from '../../components/button/button';
import CChip from '../../components/chip/chip';
import EditInstitution from '../../components/forms/edit_institution';
import CModal from '../../components/modal/modal';

import { Space } from '../../components/utils/utils';
import {
  getInstitution,
  getInstitutions,
  getOrderingRequests
} from '../../network/institution';
import { RootState } from '../../redux';
import { useAppSelector } from '../../redux/hooks';
import {
  mapStatusToColor,
  typesRequestsMapping
} from '../../types/types-requests';
import { IInstitution, IOrderingSet } from '../../utils/interfaces/interfaces';
import { variables } from '../../utils/variables';
import styles from './institution.module.scss';

const Institution = () => {
  // const user = useAppSelector((state: RootState) => state.session.user);
  const { data: user } = useGetCurrentUserQuery();

  const subordonateInstitutions = useAppSelector(
    (state: RootState) => state.session.institutions
  );

  const [openedModal, setModal] = useState(false);
  const [institutions, setInstitutions] = useState([]);
  const [requests, setRequests] = useState({ data: [] });
  const [server_institution, setInitialInstitution] = useState(
    {} as IInstitution
  );

  const updateInitialInstitution = () => {
    if (user && user.institutionId) {
      getInstitution(user.institutionId).then(({ data }) => {
        setInitialInstitution(data);

        if (data.orderingInstitutionId) {
          const query =
            institutions &&
            (institutions.find(
              (institution: IInstitution) =>
                institution.id === data.orderingInstitutionId
            )! as IInstitution) &&
            (institutions.find(
              (institution: IInstitution) =>
                institution.id === data.orderingInstitutionId
            )! as IInstitution);

          setInitialInstitution({
            ...data,
            orderingInstitutionName: query ? query.name : ''
          });
        }
      });
    }
  };

  const getRequests = () => {
    user &&
      getOrderingRequests(user.institutionId).then(({ data }) =>
        setRequests(data)
      );
  };

  const findInstitution = (institutionId: number): IInstitution | undefined =>
    institutions
      ? institutions.find(
          (institution: IInstitution) => institution.id === institutionId
        )
      : ({} as IInstitution);
  useEffect(() => {
    updateInitialInstitution();
    getRequests();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  useEffect(() => {
    getInstitutions().then(({ data }) => {
      setInstitutions(data.data);
    });
    // eslint-disable-next-line
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.rowInfo}>
        <p className='subheading-dark bold'>Gestionare date instituție</p>
        <Space vertical='2vh' />
        <CButton
          type='button'
          label='Editează informații'
          onClick={() => setModal(true)}
        />
      </div>
      <Space vertical='2vh' />
      <div>
        <div className={styles.information}>
          <div className='wrap fullWidth justify-between'>
            <div className='column'>
              <p className='body-dark bold'>Nume</p>
              <Space vertical={variables.verticalSpace} />
              {server_institution.name ? (
                <p className='body-dark'>{server_institution.name}</p>
              ) : (
                <Skeleton active paragraph={false} />
              )}
              <Space vertical={variables.verticalSpace} />
              <Space vertical={variables.verticalSpace} />
              <p className='body-dark bold'>CUI</p>
              <Space vertical={variables.verticalSpace} />
              <p className='body-dark'>
                {server_institution.cui || 'Încă nu ați setat un CUI.'}
              </p>
            </div>

            <Space horizontal={variables.verticalSpace} />
            <div className='column'>
              <p className='body-dark bold'>Adresa</p>
              <Space vertical={variables.verticalSpace} />
              <p className='body-dark'>
                {server_institution.address || 'Încă nu ați setat o adresă.'}
              </p>
              <Space vertical={variables.verticalSpace} />
              <Space vertical={variables.verticalSpace} />
              <p className='body-dark bold'>Instituție ordonatoare</p>
              <Space vertical={variables.verticalSpace} />
              <p className='body-dark'>
                {server_institution.orderingInstitutionName ||
                  'Încă nu ați setat o instituție ordonatoare.'}
              </p>
            </div>
          </div>
        </div>
        <div className={styles.subordonated}>
          <Space vertical={variables.verticalSpace} />
          <Space vertical={variables.verticalSpace} />
          <p className='subheading-dark bold p-padding'>
            Lista instituții subordonate
          </p>
          {subordonateInstitutions && subordonateInstitutions.length === 0 && (
            <p className='body-dark p-padding'>
              Momentan nu aveți nicio instituție subordonată.
            </p>
          )}
          <div className='p-padding'>
            {subordonateInstitutions &&
              subordonateInstitutions.length > 0 &&
              subordonateInstitutions.map((institution: IInstitution) => (
                <CChip key={institution.id} label={institution.name} />
              ))}
          </div>
        </div>
        <div className={styles.history}>
          <Space vertical={variables.verticalSpace} />
          <Space vertical={variables.verticalSpace} />
          <p className='subheading-dark bold'>
            Istoricul cererilor de ordonare a instituției
          </p>
          {requests.data && requests.data.length === 0 && (
            <p className='body-dark'>Momentan nu aveți nicio cerere.</p>
          )}
          {requests.data &&
            requests.data.length > 0 &&
            requests.data.map((request: IOrderingSet) => (
              <div
                key={request.id}
                className={`${styles.cardRequest} ${mapStatusToColor(
                  request.status
                )}`}
              >
                <p className='body-dark bold faded'>
                  {typesRequestsMapping(request.status)}
                </p>
                <p className='body-dark'>
                  Cerere către institutia{' '}
                  <span className='bold'>
                    {findInstitution(request.ordinateInstitutionId)!.name}
                  </span>{' '}
                  pentru poziția de ordonatoare a institutei.
                </p>
              </div>
            ))}
        </div>
        <Space vertical={variables.verticalSpace} />
        <div className={styles.hline}>
          <Space horizontal={variables.horizontalPadding} />
          <IoInformationCircle />
          <p className='body-light'>
            Prin selectarea unei instituții ordonatoare veți permite unei
            instituții să va urmărească rapoartele CCR și monitorizările,
            împreună cu măsurile acestora. Instituția ordonatoare nu va putea
            edita nicio informație ce aparține acestei instituții.
          </p>
        </div>
      </div>
      <CModal opened={openedModal} openModal={setModal}>
        <EditInstitution
          institutions={institutions}
          callback={() => {
            updateInitialInstitution();
            getRequests();
            setModal(false);
          }}
        />
      </CModal>
      <div className={styles.vline} />{' '}
    </div>
  );
};

export default Institution;
